module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av679-025af7b45d8e4666f064c62a3bc9e479.jpg";